<template>
  <div class="ticket-activation-checker">
    <slot v-if="showSlot"></slot>
    <div v-else>
        <div v-if="confermaTicketFeedback.show && confermaTicketFeedback.type === 'success'" class="alert alert-success" role="alert">
            <div style="margin-bottom: 10px;" v-html="confermaTicketFeedback.message"></div>
        </div>
        <div v-else-if="confermaTicketFeedback.show && confermaTicketFeedback.type === 'error'" class="alert alert-danger" role="alert">
            <div style="margin-bottom: 10px;" v-html="confermaTicketFeedback.message"></div>
        </div>
        <div class="col-md-6">
            <button
              :onclick="this.restartQuiz"
              class="nuovo-questionario float-end btn btn-danger btn-lg pull-right col-lg-6 col-xs-12"
            >
              <span class="bi-arrow-clockwise"></span
              >{{ intl[$store.state.lang]["new-quiz"] }}
            </button>
          </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import { apiUrls } from "../../api/apiUrls";
export default {
  name: "questionario",
  components: {},
  props: {
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        console.log("Pagina loader callback : ", value);
      },
    },
    onRicominciaQuestionarioClickCallback: {
      type: Function,
      default: (value) => {
        console.log("Rinizia questionario callback checkticketactivation : ", value);
      },
    },
  },

  created() {},
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.has("key")){
        this.showSlot = true
    }else{
        this.checkTicketConfirmKey()
    }
  },

  data: function () {
    return {
      intl: intl,
      ticketActivationLoader: false,
      showSlot: false,
      confermaTicketFeedback: {
        show: false,
        type: "", // success o error
        message: "",
      },
    };
  },
  methods: {
    resetUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete("key");
      let newUrl = `${window.location.origin}${window.location.pathname}`;
      if (urlParams.toString() !== "") {
        newUrl += `?${urlParams.toString()}`;
      }
      newUrl += window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
      this.showSlot = true;
    },
    restartQuiz() {
      const lastSurveyLog = localStorage.getItem(
        this.$store?.state?.libraryWiperConfig?.lastSurveyLocalstorageId
      );
      if (lastSurveyLog) {
        this.ticketActivationLoader = true;
        axios
          .put(apiUrls["edit_survey_log"] + lastSurveyLog, {
            finished: 1,
          })
          .then((response) => {})
          .catch((error) => {})
          .finally(() => {
            localStorage.removeItem(
              this.$store?.state?.libraryWiperConfig?.lastSurveyLocalstorageId
            );
            this.ticketActivationLoader = false;
            this.resetUrl();
            this.onRicominciaQuestionarioClickCallback();
          });
      } else {
        this.resetUrl();
        this.onRicominciaQuestionarioClickCallback();
      }
    },
   /*  restartQuiz() {
        localStorage.removeItem('id_survey_log_not_ended_assistenza')
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.delete('key');
        let newUrl = `${window.location.origin}${window.location.pathname}`;
        if (urlParams.toString() !== '') {
            newUrl += `?${urlParams.toString()}`;
        }
        newUrl += window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
        this.showSlot = true
    }, */
    checkTicketConfirmKey() {
      const urlParams = new URLSearchParams(window.location.search);
    /*   const axiosInstance = axios.create({
        baseURL: 'http://10.239.11.14/wiper_assistenza_proxy/api/'
      }); */
      if (urlParams.has("key")) {
        const keyValue = urlParams.get("key");
       
        this.ticketActivationLoader = true;
       
        axios
          .post(apiUrls["check_ticket_activation"], {
            key: keyValue,
          })
          .then((response) => {
            if (response?.data?.message) {
              if (response.data.message === "attivazione effettuata") {
                this.confermaTicketFeedback.show = true;
                this.confermaTicketFeedback.type = "success";
                this.confermaTicketFeedback.message = this.intl[this.$store.state.lang]["ticket-attivato-success"];
              }else{
                this.showSlot = true;
              }
            }
            this.ticketActivationLoader = false;
          })
          .catch((error) => {
            if(error?.response?.status === 404){
                this.showSlot = true;
            }else{
                this.confermaTicketFeedback.show = true;
                this.confermaTicketFeedback.type = "error";
                this.confermaTicketFeedback.message = this.intl[this.$store.state.lang]["ticket-attivato-error"];
                this.showSlot = false;
                
            }
            this.ticketActivationLoader = false;
          });
      }
    },
  },
  watch: {
    ticketActivationLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ ticketActivation: newValue });
        }
      },
      deep: true,
    },
  },
  computed: {
 
  },
  unmounted() {},
};
</script>
